// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3paZR","left":"InfoRow_left__2qnkO"};